<template>
  <modal
    name="modal-checkout"
    transition="pop-out"
    :width="modalWidth"
    :focus-trap="true"
    :min-width="200"
    :min-height="200"
    :scrollable="true"
    :reset="true"
    height="auto"
  >
    <div class="row justify-content-center">
      <div class="col-lg-12">
        <card
          type="secondary"
          shadow
          header-classes="bg-white pb-5"
          body-classes="px-lg-5 py-lg-5"
          class="border-0"
        >
          <div class="box">
            <div class="box-part" id="bp-left">
              <div class="text-center text-muted mb-4">
                <small>select additional details</small>
              </div>
              <div class="col-lg-6 col-sm-12">
                <h6>Check-In Date</h6>
                <div
                  class="
                    input-daterange
                    datepicker
                    row
                    align-items-center
                    flatpickr
                  "
                >
                  <div class="col">
                    <!-- <base-input addon-left-icon="fa-lg calendar"> -->
                    <base-input addon-right-icon="fa fa-calendar">
                      <flat-picker
                        slot-scope="{ focus, blur }"
                        @on-open="focus"
                        @on-close="blur"
                        @input="checkdates"
                        :config="{ allowInput: true, minDate: 'today' }"
                        class="form-control datepicker"
                        v-model="datein"
                      ></flat-picker>
                    </base-input>
                    <!-- <i class="fa fa-calendar fa-lg calendar" aria-hidden="true"></i> -->
                  </div>
                </div>
                <h6 class="mt-2">{{ datein | formatDate }}</h6>
              </div>
              <div class="col-lg-6 col-sm-12">
                <h6>Check-Out Date</h6>

                <div class="input-daterange datepicker row align-items-center">
                  <div class="col">
                    <base-input addon-right-icon="fa fa-calendar">
                      <flat-picker
                        slot-scope="{ focus, blur }"
                        @on-open="focus"
                        @on-close="blur"
                        :config="{ allowInput: true, minDate: datein }"
                        class="form-control datepicker"
                        v-model="dateout"
                      ></flat-picker>
                    </base-input>
                  </div>
                </div>
                <h6 class="mt-2">{{ dateout | formatDate }}</h6>
              </div>

              <div class="col-lg-12 col-sm-12">
                <h6>Guests & Rooms</h6>
                <input
                  v-model="roomstring"
                  class="form-control"
                  @click="showRoomPopup"
                  value
                  placeholder="Select Rooms & No of Guests"
                />
                <div v-show="showselectrooms" class="selectroom">
                  <div class="row">
                    <div class="col-lg-6 col-sm-12">
                      <h6>Rooms</h6>
                      <number-input
                        @change="checkroom"
                        v-model="trooms"
                        :min="1"
                        :max="6"
                        inline
                        controls
                      ></number-input>
                    </div>
                    <div class="col-lg-6 col-sm-12">
                      <h6>Adults</h6>
                      <number-input
                        @change="checkadults"
                        :disabled="fullguests"
                        v-model="guests"
                        :min="1"
                        :max="12"
                        inline
                        controls
                      ></number-input>
                    </div>
                    <div class="col-lg-6 col-sm-12">
                      <h6>Children Blow 6 Year</h6>
                      <number-input
                        :disabled="fullguests"
                        @change="totalguests"
                        v-model="guestsChildren"
                        :min="0"
                        :max="6"
                        inline
                        controls
                      ></number-input>
                    </div>
                    <div class="col-lg-6 col-sm-12">
                      <h6>Children 6-12 Year</h6>
                      <number-input
                        :disabled="fullguests"
                        @change="totalguests"
                        v-model="guestsChildrenabove"
                        :min="0"
                        :max="6"
                        inline
                        controls
                      ></number-input>
                    </div>
                    <div class="col-lg-6 col-sm-12">
                      <h6>&nbsp;</h6>
                      <button
                        @click="showRoomPopup"
                        type="button"
                        class="btn btn-warning"
                      >
                        Done
                      </button>
                    </div>
                  </div>
                </div>
                <div class="col-lg-12 col-sm-12 mt-3">
                  <p>
                    <Button
                      @click="savecheckout"
                      class="btn btn-primary text-center"
                      >Confirm</Button
                    >
                  </p>
                </div>
              </div>
            </div>
          </div>
        </card>
      </div>
    </div>
  </modal>
</template>
<script>
const MODAL_WIDTH = 656;
import { APIURLS } from "../../api/constants";
import axios from "axios";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import moment from "moment";

export default {
  name: "DemoCheckoutModal",
  components: {
    flatPicker,
  },
  data() {
    return {
      modalWidth: MODAL_WIDTH,
      show: false,
      loginemail: "",
      loginpassword: "",
      showLoading: false,
      showSuccess: false,
      loginErrorString: "Incorrect Username or Password, Please try again",
      international: "no",
      guests: 2,
      trooms: 1,
      guestsChildren: 0,
      guestsChildrenabove: 0,
      maxguests: 12,
      totalguest: 0,
      fullguests: false,
      showselectrooms: false,
      roomstring: "",
      datein: new Date(),
      dateout: new Date().setDate(new Date().getDate() + 1),

      dates: {
        simple: "2016-07-17",

        rangein: new Date(),
        rangeout: new Date().setDate(new Date().getDate() + 1),
      },
    };
  },

  created() {
    this.modalWidth =
      window.innerWidth < MODAL_WIDTH ? MODAL_WIDTH / 2 : MODAL_WIDTH;

    var dateIn = localStorage.getItem("checkin");
    var dateOut = localStorage.getItem("checkout");
    var g = localStorage.getItem("guests");
    var gc = localStorage.getItem("guestsChildren");
    var gav = localStorage.getItem("guestsChildrenabove");
    var totalguest = localStorage.getItem("totalguest");
    var tr = localStorage.getItem("trooms");

    if (tr != null) {
      if (tr != "") {
        this.trooms = tr;
      }
    }
    if (g != null && gc != null) {
      if (g != "" && gc != "") {
        this.guests = g;
        if (gc > 0) {
          this.guestsChildren = gc;
        } else {
          this.guestsChildren = 0;
        }
      }
      if (gav > 0) {
        this.guestsChildrenabove = gav;
      } else {
        this.guestsChildrenabove = 0;
      }

      this.roomstring =
        this.guests +
        this.guestsChildren +
        this.guestsChildrenabove +
        " Guests and " +
        this.trooms +
        " Room(s)";
    }

    if (dateIn != null && dateOut != null) {
      if (dateIn != "" && dateOut != "") {
         this.datein = moment(String(dateIn)).format("YYYY-MM-DD");
        this.dateout = moment(String(dateOut)).format("YYYY-MM-DD");
      }
    }

    
  },
  beforeMount() {
    if (localStorage.getItem("combohotel") == "combe") {
    //  alert(localStorage.getItem("combohotel"));
    }
  },

  mounted() {
    var dateIn = localStorage.getItem("checkin");
    var dateOut = localStorage.getItem("checkout");
    var g = localStorage.getItem("guests");
    var gc = localStorage.getItem("guestsChildren");
    var tr = localStorage.getItem("trooms");
    var totalrooms = localStorage.getItem("trooms");
    var maxguest = localStorage.getItem("totalguest");
    var gav = localStorage.getItem("guestsChildrenabove");

    if (tr != null) {
      if (tr != "") {
        this.trooms = tr;
      }
    }
    if (g != null && gc != null) {
      if (g != "" && gc != "") {
        this.guests = g;
        if (gc > 0) {
          this.guestsChildren = gc;
        } else {
          this.guestsChildren = 0;
        }
      }
      if (gav > 0) {
        this.guestsChildrenabove = gav;
      } else {
        this.guestsChildrenabove = 0;
      }
    }

    if (dateIn != null && dateOut != null) {
      if (dateIn != "" && dateOut != "") {
        this.datein = moment(String(dateIn)).format("YYYY-MM-DD");
        this.dateout = moment(String(dateOut)).format("YYYY-MM-DD");
      }
    }
    
    this.roomstring =
      Number(this.guests) +
      this.guestsChildren +
      this.guestsChildrenabove +
      " Guests and " +
      this.trooms +
      " Room(s)";
  },

  methods: {
    savecheckout() {
      var datein1 = moment(String(this.datein)).format("YYYY-MM-DD");
      var dateout1 = moment(String(this.dateout)).format("YYYY-MM-DD");
      localStorage.setItem("checkin", datein1);
      localStorage.setItem("checkout", dateout1);
      localStorage.setItem("guests", this.guests);
      localStorage.setItem("guestsChildren", this.guestsChildren);
      localStorage.setItem("trooms", this.trooms);
      this.$root.$emit("checkoutupdated", "updated");
      this.$modal.hide("modal-checkout");
    },
    totalguests() {
      this.maxguests = 12;
      this.totalguest =
        this.guests + this.guestsChildren + this.guestsChildrenabove;
      this.maxguests =
        this.maxguests -
        this.guests -
        this.guestsChildren -
        this.guestsChildrenabove;
      //console.log(this.maxguests);
      if (this.maxguests == 0) {
        this.fullguests = true;
      }
    },
    checkadults() {
      this.maxguests = 12;
      this.maxguests = this.maxguests - this.guests;

      if (this.guests == 12) {
        this.fullguests = true;
        this.guestsChildren = 0;
        this.guestsChildrenabove = 0;
      } else if (this.guests < 12) {
        this.fullguests = false;
      }
    },
    checkroom() {
      if (this.trooms >= 1) {
        if (this.guests < this.trooms * 2) {
          this.guests = this.trooms * 2;
        } else {
          this.guests = this.trooms * 2;
        }
      }
    },
    checkdates() {
      this.dateout = "";
      this.dateout = moment(String(this.datein))
        .add(1, "day")
        .format("YYYY-MM-DD");
      this.$forceUpdate();
    },

    showRoomPopup() {
      this.showselectrooms = !this.showselectrooms;
      this.roomstring =
        this.guests +
        this.guestsChildren +
        this.guestsChildrenabove +
        " Guests and " +
        this.trooms +
        " Room(s)";
    },
  },
};
</script>
<style>
</style>